import styled from '@emotion/styled';
import { getConfig } from '@sortlist-frontend/config';
import { Tooltip } from '@sortlist-frontend/design-system/legacy';
import { ImageSourceHelper } from '@sortlist-frontend/media';

import { useSharedComponentsContext } from '../../utils';
import { getTrustedPartnerHelpUrl } from './trustedPartnerUrl';

const Flag = styled.img`
  height: 1.75rem;
  width: 1.5rem;
`;

type Props = {
  className?: string;
  isPrimary?: boolean;
};

export const TrustedFlag = ({ className, isPrimary }: Props) => {
  const { locale, Trans } = useSharedComponentsContext();
  const { publicEnv } = getConfig();

  const flagSrc = isPrimary ? 'trusted-flag-primary' : 'trusted-flag-secondary';
  const helpUrl = getTrustedPartnerHelpUrl(locale);

  const tooltipContent = (
    <Trans
      i18nKey="base:flags.trustedTooltip"
      components={{
        1: (
          // eslint-disable-next-line jsx-a11y/anchor-has-content -- content injected by Trans
          <a
            href={helpUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-inherit underline"
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
          />
        ),
      }}
    />
  );

  return (
    <Tooltip placement="bottom" title={tooltipContent}>
      <span className="inline-flex">
        <Flag
          className={className}
          src={ImageSourceHelper.fromUrl(`${publicEnv.s3Bucket}/icons/flags/${flagSrc}.svg`)}
          alt="trusted-flag"
        />
      </span>
    </Tooltip>
  );
};
